import { componentMap } from './componentMap';
import { generateFormFieldFromPropType } from './propTypeIntrospection';
/**
 * Component Generation Logic
 * Handles form data extraction and component object creation
 */
/**
 * Extracts component data from form submission event
 */
export function generateComponentObject(event) {
    const props = {};
    const target = event.target;
    const fields = Array.from(target.elements);
    for (const field of fields) {
        if (!field.name)
            continue;
        const name = field.name;
        const input = field;
        let value = field.value;
        if (input.type === 'checkbox') {
            value = input.checked;
        }
        else if (input.type === 'number') {
            value = input.value === '' ? input.value : parseFloat(input.value);
        }
        if (name !== 'type' && typeof value === 'string' && value.startsWith('{')) {
            try {
                value = JSON.parse(value);
            }
            catch (err) {
                console.log('Invalid JSON for prop:', err, name, value);
            }
        }
        if (input.type !== 'checkbox' && value === '')
            continue;
        props[name] = value;
    }
    const parentPath = props.__parentPath;
    delete props.__parentPath;
    const newComponent = {
        component: props.type,
        props: props,
        children: [] // Initialize children array for layout components
    };
    // Add path for tracking nested structure
    newComponent.path = parentPath
        ? `${parentPath}.children[${Date.now()}]`
        : `root[${Date.now()}]`;
    return { component: newComponent, parentPath };
}
/**
 * Generates form field configuration for a component
 */
export function generateFieldJSON(component, existingProps, parentPath) {
    const form = { fields: [] };
    // ADD COMPONENT TYPE FIELD (disabled in phase 2)
    form.fields.push({
        component: 'FormInput',
        props: {
            label: 'Type:',
            name: 'type',
            id: 'type',
            type: 'text',
            disabled: true,
            value: component
        }
    });
    // ADD PARENT PATH (hidden field for nested components)
    if (parentPath) {
        form.fields.push({
            component: 'FormInput',
            props: {
                name: '__parentPath',
                id: '__parentPath',
                type: 'hidden',
                value: parentPath
            }
        });
    }
    // INTROSPECT PROPTYPES TO GENERATE APPROPRIATE FIELDS
    const componentPropTypes = componentMap[component].propTypes;
    if (componentPropTypes) {
        for (const prop in componentPropTypes) {
            // Skip children as we'll handle that separately for layout components
            if (prop === 'children')
                continue;
            const propType = componentPropTypes[prop];
            const existingValue = existingProps ? existingProps[prop] : undefined;
            const field = generateFormFieldFromPropType(prop, propType, existingValue, component);
            form.fields.push(field);
        }
    }
    // ADD SUBMIT BUTTON
    const buttonText = existingProps ? 'Update ' + component : 'Add ' + component;
    form.fields.push({
        component: 'FormButton',
        props: {
            label: buttonText,
            type: 'submit',
            id: buttonText,
            text: buttonText
        }
    });
    return form;
}
